



















































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import TextField from "@/components/form/CustomPage/textField.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import CPage from "@/components/form/CustomPage/CPage.vue";
import {
  Course as ICourse,
  Registration as IRegistration
} from "@/api-v2/course/models";
import { courseApi } from "@/getinfo-api";
import EntityFiles from "@/components/fileManager/EntityFiles.vue";
import StudentTable from "@/components/students/StudentTable.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import CourseStudentsSection from "@/components/courses/CourseStudentsSection.vue";
import { Draggable, Tree } from "he-tree-vue";
import LearningUnitTree from "@/components/courses/CourseV2/LearningUnitTree.vue";
import courseRegistrations, {
  CourseRegistrationsListParams
} from "@/getinfo-api/courseRegistrations";
import { CourseInfo as ICourseInfo } from "@/api-v2/course/models";
import {
  getCurrentCompanyId,
  getCurrentEmployee,
  isDocumentManager,
  isContentManager,
  currentUserIsCompanyOwner,
  isLearningRequestManager,
  getCurrentUserId,
  isRoot
} from "@/plugins/roles";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { CourseDocumentInfo as ICourseDocumentInfo } from "@/api-v2/course-document-info/models";
import Modal from "@/components/form/Modal.vue";
import LearningGroupTable from "@/components/learning-group/LearningGroupTable.vue";
import LearningGroupTableByCourseId from "@/components/learning-group/LearningGroupTableByCourseId.vue";
import { learningGroupModule } from "@/plugins/modules-detect";

@Component({
  components: {
    LearningGroupTableByCourseId,
    LearningGroupTable,
    Modal,
    LearningUnitTree,
    CourseStudentsSection,
    CustomButton,
    StudentTable,
    EntityFiles,
    CPage,
    CBlock,
    TextField,
    Tree: Tree.mixPlugins([Draggable])
  }
})
export default class CourseV2 extends Vue {
  course!: ICourse;
  isLoading: boolean = false;
  isLoadingFiles: boolean = false;
  courseRegistration!: IRegistration;
  myRegistrations!: Array<IRegistration>;
  courseInfo!: ICourseInfo;
  courseDocumentInfo!: ICourseDocumentInfo;
  courseEnabledValue?: string;
  localCourseEnabled?: boolean;

  data() {
    return {
      localCourseEnabled: undefined,
      courseEnabledValue: undefined,
      courseInfo: undefined,
      courseDocumentInfo: undefined,
      courseRegistration: undefined,
      myRegistrations: undefined,
      course: undefined,
      courseLecturesList: undefined
    };
  }

  get employee() {
    return getCurrentEmployee();
  }

  get isLearningGroupModule() {
    return learningGroupModule();
  }

  get root() {
    return isRoot();
  }
  get breadcrumbs() {
    return [
      {
        to: { name: "courses" },
        label: this.$tc(this.$translate.Courses)
      },
      {
        label: this.course.title
      }
    ];
  }

  @Watch("localCourseEnabled")
  upd() {
    if (this.localCourseEnabled === true) {
      this.courseEnabledValue = `${this.$tc(this.$translate.Published)}`;
    } else {
      this.courseEnabledValue = `${this.$tc(this.$translate.Unpublished)}`;
    }
  }

  async getDocumentInfo() {
    if (this.employee || this.root) {
      await courseApi.CourseDocumentInfo.getCourseDocumentInfo(
        this.$route.params.id
      )
        .then(res => {
          this.courseDocumentInfo = res.data;
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    }
  }

  get userId() {
    return getCurrentUserId();
  }

  educationFinish() {
    courseApi.LearningProgress.finishCourseRegistration(
      this.courseRegistration.id
    )
      .then(() => {
        this.init();
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  statusFormatter(status: string) {
    if (status === "learning") return `${this.$tc(this.$translate.Learning)}`;
    if (status === "pause") return `${this.$tc(this.$translate.Pause)}`;
    if (status === "success") return `${this.$tc(this.$translate.Success)}`;
    if (status === "fail") return `${this.$tc(this.$translate.Failed)}`;
    if (status === "abort") return `${this.$tc(this.$translate.Canceled)}`;
    return status;
  }

  getCourseRegistration() {
    const params: CourseRegistrationsListParams = {
      courseIds: [this.$route.params.id],
      studentUserIds: [this.userId],
      statuses: ["learning"]
    };
    courseRegistrations(params)
      .then(res => {
        [this.courseRegistration] = res.data.items;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  get company() {
    if (this.$store.state.user.user.isOnlyContractor) return false;

    return getCurrentCompanyId();
  }

  getAllMyRegistrations() {
    const params: CourseRegistrationsListParams = {
      courseIds: [this.$route.params.id],
      studentUserIds: [this.userId],
      sort: "finishedAt",
      order: "DESC",
      limit: 999
    };
    courseRegistrations(params)
      .then(res => {
        this.myRegistrations = res.data.items;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  addFiles(files: any, fromDocTemplate: boolean = false) {
    this.course.attachmentsIds =
      this.course.attachmentsIds && fromDocTemplate
        ? [...this.course.attachmentsIds.map((el: any) => el.id), ...files]
        : [...files];

    this.isLoadingFiles = true;

    courseApi.Course.editCourse(this.course.id, this.course)
      .then((res: { data: ICourse }) => {
        this.course = res.data;
      })
      .finally(() => {
        this.isLoadingFiles = false;
      });
  }

  init() {
    this.isLoading = true;
    this.getCourseRegistration();
    this.getAllMyRegistrations();
    this.getDocumentInfo();
    courseApi.Course.getCourse(this.$route.params.id)
      .then(res => {
        this.course = res.data;
        document.title = this.course?.title;
      })
      .finally(() => {
        this.isLoading = false;
        this.equateCourseEnabled();
      });
    if (this.employee || this.root) {
      courseApi.CourseInfo.getCourseInfo(this.$route.params.id)
        .then(res => {
          this.courseInfo = res.data;
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    }
  }

  equateCourseEnabled() {
    this.localCourseEnabled = this.course.enabled;
  }

  get documentManager() {
    return isDocumentManager();
  }
  get contentManager() {
    return isContentManager();
  }
  get isCompanyOwner() {
    return currentUserIsCompanyOwner();
  }
  get learningRequestManager() {
    return isLearningRequestManager();
  }

  checkAccess() {
    if (
      this.documentManager &&
      !this.root &&
      !this.isCompanyOwner &&
      !this.learningRequestManager &&
      !this.contentManager
    ) {
      this.$router.push({ name: "error" });
    }
  }

  async created() {
    this.checkAccess();
    await this.init();
  }
}
